import { createContext } from "react";

const LoadingContext = createContext(false);
const FetchStatusContext = createContext(null);

export { LoadingContext, FetchStatusContext }